import App from "@/App.vue";
import { createApp } from "vue";
import i18n from "./i18n";
import router from "./router";

import Buefy from "buefy";
import "buefy/dist/buefy.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAngleUp,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faArchive,
  faArrowDown,
  faArrowLeft,
  faArrowUp,
  faBan,
  faBars,
  faCalendar,
  faCalendarDay,
  faCaretDown,
  faCaretRight,
  faCaretUp,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faClock,
  faDownload,
  faDraftingCompass,
  faEdit,
  faEllipsisH,
  faEnvelope,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLinkSquareAlt,
  faEye,
  faEyeSlash,
  faFile,
  faFilter,
  faGlobe,
  faInfo,
  faInfoCircle,
  faKey,
  faLink,
  faMinus,
  faMinusSquare,
  faPaperPlane,
  faPenSquare,
  faPlus,
  faPoll,
  faQuestion,
  faQuestionCircle,
  faRedo,
  faSearch,
  faSearchPlus,
  faShare,
  faSignInAlt,
  faSignOutAlt,
  faSort,
  faSortAmountDown,
  faSortDown,
  faSortUp,
  faSpinner,
  faSquare,
  faStream,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faUnlock,
  faUpload,
  faUserAstronaut,
  faUserEdit,
  faUserPlus,
  faUsersCog,
  faVial,
  faWrench,
  faHome,
  faToolbox,
  faCog,
  faArrowRight,
  faExchangeAlt,
  faUserShield,
  faCity,
  faArrowsAltV,
  faArrowsAltH,
  faSlidersH,
  faUsers,
  faUser,
  faCircleNotch,
  faSave,
  faHardDrive,
  faFilePen,
  faWindowRestore,
  faTableCellsRowUnlock,
  faTableList,
  faShieldHalved,
  faBuildingShield,
  faHotel,
  faFileCirclePlus,
  faCalendarPlus,
  faMagnifyingGlassPlus,
  faFileCsv,
  faFileCircleCheck,
  faTag,
  faTags,
  faExpandAlt,
  faCompressAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  faCalendar as farCalendar,
  faCalendarDays as farCalendarDays,
  faCheckSquare as farCheckSquare,
  faFloppyDisk as farFloppyDisk,
  faMinusSquare as farMinusSquare,
  faSquare as farSquare,
  faTimesCircle as farTimesCircle,
} from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "@/style/global.scss";
import services from "@/composable/services";

library.add(
  farFloppyDisk,
  farCalendarDays,
  farCalendar,
  farSquare,
  farMinusSquare,
  farCheckSquare,
  farTimesCircle,
);
library.add(
  faArrowsAltV,
  faArrowsAltH,
  faUsers,
  faUser,
  faCircleNotch,
  faSlidersH,
  faUsersCog,
  faUserShield,
  faLink,
  faCircle,
  faEye,
  faEyeSlash,
  faFile,
  faPlus,
  faMinus,
  faExclamationCircle,
  faQuestionCircle,
  faCheck,
  faCheckCircle,
  faPenSquare,
  faSquare,
  faMinusSquare,
  faCheckSquare,
  faSignOutAlt,
  faGlobe,
  faUpload,
  faFilter,
  faSearch,
  faSearchPlus,
  faArrowUp,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faAngleUp,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faBan,
  faWrench,
  faPoll,
  faDraftingCompass,
  faCaretUp,
  faCaretDown,
  faTimes,
  faTrashAlt,
  faDownload,
  faVial,
  faCaretRight,
  faSignInAlt,
  faUserPlus,
  faUserAstronaut,
  faUsersCog,
  faUserEdit,
  faClock,
  faEnvelope,
  faUnlock,
  faInfoCircle,
  faKey,
  faChevronUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCalendarDay,
  faPaperPlane,
  faArrowLeft,
  faExternalLinkSquareAlt,
  faCalendar,
  faRedo,
  faExchangeAlt,
  faStream,
  faSort,
  faSortAmountDown,
  faSortDown,
  faSortUp,
  faArchive,
  faTimesCircle,
  faEdit,
  faInfo,
  faQuestion,
  faEllipsisH,
  faSpinner,
  faExclamationTriangle,
  faShare,
  faBars,
  faHome,
  faToolbox,
  faCog,
  faCity,
  faSave,
  faHardDrive,
  faFilePen,
  faWindowRestore,
  faTableCellsRowUnlock,
  faTableList,
  faShieldHalved,
  faBuildingShield,
  faHotel,
  faFileCirclePlus,
  faCalendarPlus,
  faMagnifyingGlassPlus,
  faFileCsv,
  faFileCircleCheck,
  faTag,
  faTags,
  faExpandAlt,
  faCompressAlt,
);

// Validation
import { ValidationService } from "@/services/validation/ValidationService";
ValidationService.init();
import UserRegister from "@/components/login/UserRegister.vue";
import inputMask from "@/directives/inputMask";
import { Locales } from "@/utils/LocaleUtils";

const app = createApp(App)
  .use(router)
  .use(i18n)
  .use(Buefy, {
    defaultIconComponent: "font-awesome-icon",
    defaultIconPack: "fas",
  })
  .directive("input-mask", inputMask)
  .component("font-awesome-icon", FontAwesomeIcon)
  .component("UserRegister", UserRegister);

app.mount("#app");

const lang = localStorage.getItem("lang") || navigator.language.slice(0, 2) || Locales.FRENCH;
services.userPreferencesService.setUserPrefLocale(lang, app);

export default app;
